const Accounts = () => import('./accounts.vue');
const Customers = () => import('./customers.vue');
const Suppliers = () => import('./suppliers.vue');

export default [
    {
        path: '/account-balances',
        component: Accounts
    },
    {
        path: '/customer-balances',
        component: Customers
    },
    {
        path: '/supplier-balances',
        component: Suppliers
    }
]

